import {ITariffAssigment} from '../pages/Profile/types';

export const SUBSCRIPTION_EXPIRY_REMINDER_DAYS = 3;

const STORAGE_PREFIX = 'tyrebase_subscription_expiry_banner_dismissed';

export const getSubscriptionExpiryBannerStorageKey = (
    userId: number,
    endsAt: string,
): string => `${STORAGE_PREFIX}_${userId}_${endsAt}`;

export const getLocalDateKey = (date = new Date()): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

export const getCalendarDaysUntil = (endsAtIso: string, now = new Date()): number => {
    const endsAt = new Date(endsAtIso);

    if (Number.isNaN(endsAt.getTime())) {
        return Number.NaN;
    }

    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const endsStart = new Date(endsAt.getFullYear(), endsAt.getMonth(), endsAt.getDate());

    return Math.round((endsStart.getTime() - todayStart.getTime()) / (24 * 60 * 60 * 1000));
};

export const isSubscriptionExpiryBannerDismissedToday = (storageKey: string): boolean => {
    try {
        return localStorage.getItem(storageKey) === getLocalDateKey();
    } catch {
        return false;
    }
};

export const dismissSubscriptionExpiryBanner = (userId: number, endsAt: string): void => {
    try {
        localStorage.setItem(
            getSubscriptionExpiryBannerStorageKey(userId, endsAt),
            getLocalDateKey(),
        );
    } catch {
    }
};

/** Подписка истекает в ближайшие SUBSCRIPTION_EXPIRY_REMINDER_DAYS дней (включая сегодня). */
export const isSubscriptionExpiringSoon = (endsAt: string | null | undefined): boolean => {
    if (!endsAt) {
        return false;
    }

    const daysLeft = getCalendarDaysUntil(endsAt);

    return !Number.isNaN(daysLeft)
        && daysLeft >= 0
        && daysLeft <= SUBSCRIPTION_EXPIRY_REMINDER_DAYS;
};

export const shouldShowSubscriptionExpiryBanner = (
    active: ITariffAssigment | null,
    userId: number | null,
): boolean => {
    if (!userId || !active?.ends_at) {
        return false;
    }

    if (!isSubscriptionExpiringSoon(active.ends_at)) {
        return false;
    }

    const storageKey = getSubscriptionExpiryBannerStorageKey(userId, active.ends_at);

    return !isSubscriptionExpiryBannerDismissedToday(storageKey);
};
